export default "__VITE_ASSET__CKY4KVoJ__"